import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'

import { LOGOUT } from './auth.module.js'
import router from '@/router'

import { eventBus } from '@/main'

// action types
export const GET_INTEGRATIONS = 'getIntegrations'

// mutation types
export const SAVE_INTEGRATIONS = 'saveIntegrations'
export const CLEAR_INTEGRATIONS = 'clearIntegrations'
export const SET_FAILED_INTEGRATION_GET_STATUS = 'setFailedIntegrationGetStatus'

const SET_RESPONSE_STATE = 'setResponseState'
export const TOAST_INTEGRATIONS = 'showToast/ResellerIntegrations'

const state = {
  integrationsList: [],
  failedIntegrationGetStatus: undefined,

  responses: {
    getIntegrations: false,
  },
}

const getters = {
  integrationsList(state) {
    return state.integrationsList
  },
  failedIntegrationGetStatus(state) {
    return state.failedIntegrationGetStatus
  },
  integrationsResponses: state => type => {
    return state.responses[type]
  }
}

const actions = {
  [GET_INTEGRATIONS](context, { id }) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'getIntegrations', status: true })
        eventBus.$emit('startProgress')
        ApiService.setHeader()
        ApiService.get(`${process.env.VUE_APP_RESELLER}/${id}/integrations`)
          .then(({ data }) => {
            context.commit(SET_FAILED_INTEGRATION_GET_STATUS, false)
            context.commit(SAVE_INTEGRATIONS, data)
            resolve(data)
          })
          .catch(err => {
            context.commit(SET_FAILED_INTEGRATION_GET_STATUS, true)
            eventBus.$emit(TOAST_INTEGRATIONS, {
              message: err.message,
              variant: 'danger'
            })
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'getIntegrations', status: false })
            eventBus.$emit('endProgress')
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
}

const mutations = {
  [SAVE_INTEGRATIONS](state, data) {
    state.integrationsList = data
  },
  [CLEAR_INTEGRATIONS](state) {
    state.integrationsList = []
  },
  [SET_FAILED_INTEGRATION_GET_STATUS](state, value) {
    state.failedIntegrationGetStatus = value
  },
  [SET_RESPONSE_STATE](state, { type, status }) {
    state.responses[type] = status
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
